// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (width <= 640px){
    .help__heading{
      font-size:1.5rem;
      line-height:2.25rem;
    }
  }
@media (width > 640px){
    .help__description{
      font-size:1.125rem;
      line-height:1.75rem;
    }
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
